module.exports = __webpack_public_path__ + "img/concrete-u-mask.32c75081.png";